import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Barvanje",
  "description": "",
  "published": "2006-05-07T00:00:00.000Z",
  "redirect_from": ["/blog/barvanje/swizec/419"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "/includes/editor_upload/Image/sneeks/sneek1.jpg",
        "alt": "Predogled"
      }}></img></p>
    <p>{`Z veseljem oznanjam, da je risanje stripa konÄano in je na vrsti le še barvanje vsega skupaj, kar zna trajati nekaj Äasa. Predvideno je, da naj bi strip bil pripravljen nekako do sredine tedna. Slika, ki jo vidite zgoraj, je neke vrste predogled stripa in predstavlja zadnjo sliÄico brez teksta in verjetno v ne ravno dokonÄni obliki.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      